import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PortalConfigurationRolesSettingsKeys } from 'types';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { usePortalConfigurationChecks } from 'modules/portalConfigurations';
import { menuConstructorSelectors } from '../model';
import { CommonDataContext } from '../../../contexts/CommonDataContext';

export function useAftermarketPermissions() {
  const { isAftermarketPartner, isSuperAdminOrSingleAccount } = useContext(CommonDataContext);

  const proposalMenu = useSelector(menuConstructorSelectors.proposalsMenu);

  const { checkPortalConfigEntryForCurrentUserRole } = usePortalConfigurationChecks();

  const { hasWriteAccess, hasReadOnlyAccess } = useMemo(() => {
    if (isAftermarketPartner) {
      return {
        hasWriteAccess: true,
        hasReadOnlyAccess: true,
      };
    }

    // hotfix for now - make current( and all) shared menus read only. No need useMemo once this logic will be unhardcoded
    if (!!proposalMenu?.linkedFromCriteria) {
      return {
        hasWriteAccess: false,
        hasReadOnlyAccess: true,
      };
    }
    return {
      hasWriteAccess:
        checkPortalConfigEntryForCurrentUserRole(
          PortalConfigurationType.Aftermarket,
          PortalConfigurationRolesSettingsKeys.AssignedOnly
        ) || isSuperAdminOrSingleAccount,
      hasReadOnlyAccess: checkPortalConfigEntryForCurrentUserRole(
        PortalConfigurationType.Aftermarket,
        PortalConfigurationRolesSettingsKeys.ReadOnly
      ),
    };
  }, [proposalMenu, isSuperAdminOrSingleAccount]);

  return {
    hasWriteAccess,
    hasReadOnlyAccess,
  };
}
